import { language_codes } from "../api";
import type { SunstarGumSSOModel } from "../hooks";
import translation_sso_en from "../data/translation_sso_en.json" with { type: "json" };
import translation_sso_de from "../data/translation_sso_de.json" with { type: "json" };
import translation_sso_fr from "../data/translation_sso_fr.json" with { type: "json" };
import translation_sso_it from "../data/translation_sso_it.json" with { type: "json" };

export type translations = GQL_AEM.CheckoutTranslationModels & SunstarGumSSOModel;

const getTranslationJson = (lang: string) => {
  const lang_jsons = {
    en: translation_sso_en,
    de: translation_sso_de,
    fr: translation_sso_fr,
    it: translation_sso_it,
  };
  let only_lang = lang.split("-")[0];
  if (!language_codes.includes(only_lang)) {
    only_lang = "en";
  }
  // const translationsJson: GQL_AEM.CheckoutTranslationModels &
  //   SunstarGumSSOModel = await import(
  //   "../data/translation_sso_" + only_lang.toLowerCase() + ".json",
  //   {
  //     with: { type: "json" },
  //   }
  // );
  const translationsJson: translations = lang_jsons[only_lang as keyof typeof lang_jsons];
  return translationsJson;
};

export default getTranslationJson;
